import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "chevron-right-green",
  "use": "chevron-right-green-usage",
  "viewBox": "0 0 11 18",
  "content": "<symbol viewBox=\"0 0 11 18\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"chevron-right-green\">\r\n    <polygon id=\"chevron-right-green_Shape\" stroke=\"none\" fill=\"#cbd46c\" fill-rule=\"evenodd\" transform=\"translate(5.050000, 8.700000) scale(-1, 1) translate(-5.050000, -8.700000) \" points=\"8.7 17.4 0 8.7 8.7 0 10.1 1.4 2.8 8.7 10.1 16\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol